import type { GetCaseByIdNormalized as Case } from '@messenger/types'
import { logger, EventCategory } from 'utils/logger'

/**
 * Updates the `customData.caseDetails` property on all active TinyMCE editor instances.
 * This allows plugins and UI components (like menus or dialogs) that read from
 * `editor.customData` to access the latest details when they are invoked.
 */
export const refreshTinyMCEEditors = ({
  refreshedCaseDetails,
}: {
  refreshedCaseDetails?: Case
}) => {
  const tinymceExists = window?.tinymce?.editors
  if (!tinymceExists) {
    logger.warn({
      message: 'refreshTinyMCEs_no_editors_found',
      category: EventCategory.EDIT,
    })
    return
  }

  Object.values(window.tinymce!.editors).forEach((editor) => {
    if (!editor || typeof editor.customData !== 'object') {
      logger.warn({
        message: 'refreshTinyMCEs_missing_customData',
        category: EventCategory.EDIT,
        data: { editorId: editor?.id },
      })
      return
    }

    try {
      if (refreshedCaseDetails)
        editor.customData.caseDetails = refreshedCaseDetails
    } catch (error) {
      logger.error({
        message: 'case_details_refresh_customData_failed',
        category: EventCategory.ERROR,
        error: new Error(
          `Failed refreshing customData: ${error instanceof Error ? error.message : String(error)}`,
        ),
        data: {
          editorId: editor?.id,
          caseDetails: refreshedCaseDetails,
        },
      })
    }
  })
}
